import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatLimit(options?: UseQueryOptions<number>) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-conversations-limit"],
    queryFn: async () => {
      const { data } = await api.getChatLimit();
      return data;
    },
    ...options,
    refetchInterval: 16000,
  });
}
